import { useContext, useRef, useEffect, useState } from 'react';

import styles from './ParticipantDragComponent.module.css';

import { GlobalContext } from '../../../contexts/globalContext';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-fe6b9b7683/icons';

import InitialsCircleComponent from '../../commons/InitialsCircleComponent';
import TagComponent from '../../projectList/TagComponent';

const ParticipantDragComponent = ({ user, scale = 1, deskNumber, border, isOnline, emailSent }) => {
    const { currentParticipant } = useContext(GlobalContext);

    const nameRef = useRef(null);
    const [isScrollable, setIsScrollable] = useState(false);

    useEffect(() => {
        const checkScroll = () => {
            if (nameRef.current) {
                const containerWidth = nameRef.current.offsetWidth;
                const textWidth = nameRef.current.scrollWidth;
                setIsScrollable(textWidth > containerWidth);
            }
        };

        setTimeout(checkScroll, 0); // Ensure it runs after the component mounts

        window.addEventListener("resize", checkScroll); // Update on resize
        return () => window.removeEventListener("resize", checkScroll);
    }, [user.name]);

    return (
        <div className={styles.component} style={{
            transform: `scale(${scale}) translate(-50%,-50%)`,
            transformOrigin: "left top",
            border,
            backgroundColor: currentParticipant?._id === user._id ? "#0857424D" : "",
            touchAction: currentParticipant?._id === user._id ? "none" : "",
            userSelect: currentParticipant?._id === user._id ? "none" : "",
            pointerEvents: currentParticipant?._id === user._id ? "none" : "",
            zIndex: 3
        }}>
            <InitialsCircleComponent name={user.name} style={{
                marginLeft: -6, marginTop: -6, height: 121, width: 121,
                border: "6px solid #0D0032", marginBottom: 10
            }} />
            {emailSent && <div className={styles.emailSentConf}>
                <FontAwesomeIcon className={styles.emailSentIcon} icon={byPrefixAndName.fas['envelope-circle-check']} />
                INVITED
            </div>}
            {deskNumber && <div className={styles.assignedDeskNumber} style={{ zIndex: 10 }}>{deskNumber}</div>}
            {isOnline && <div style={{ position: "absolute", top: 40, right: 30 }}><TagComponent text="Connected" /></div>}
            <label className={styles.role}>{user.role}</label>
            
            <label className={`${styles.name} ${isScrollable ? styles.scrollActive : ""}`} ref={nameRef}>
                <span>{user.name}</span>
            </label>

            <label className={styles.function}>{user.function?.name}</label>
            <label className={styles.function}>{user.department?.name}</label>
        </div>
    );
};

export default ParticipantDragComponent;
